import { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import HELP, { searchHelp, CATEGORIES } from '../helpContent';

export default function HelpPage() {
  const location = useLocation();
  const hashId = location.hash?.replace('#', '');
  const [query, setQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState(null);

  const results = useMemo(() => {
    let filtered = query ? searchHelp(query) : HELP;
    if (activeCategory) filtered = filtered.filter(h => h.category === activeCategory);
    return filtered;
  }, [query, activeCategory]);

  const groupedResults = useMemo(() => {
    const map = new Map();
    results.forEach(h => {
      if (!map.has(h.category)) map.set(h.category, []);
      map.get(h.category).push(h);
    });
    return map;
  }, [results]);

  return (
    <div className="page help-page">
      <div className="page-header">
        <div>
          <h1>Help &amp; Glossary</h1>
          <p className="page-subtitle">Definitions for every term, column, and feature in Ledger</p>
        </div>
      </div>

      <div className="help-search">
        <input
          type="text"
          placeholder="Search terms, definitions, columns..."
          value={query}
          onChange={e => { setQuery(e.target.value); setActiveCategory(null); }}
          className="help-search-input"
          autoFocus
        />
        {query && (
          <span className="help-result-count">{results.length} result{results.length !== 1 ? 's' : ''}</span>
        )}
      </div>

      <div className="help-categories">
        <button
          className={`help-category-btn ${!activeCategory ? 'active' : ''}`}
          onClick={() => setActiveCategory(null)}
        >All</button>
        {CATEGORIES.map(cat => (
          <button
            key={cat}
            className={`help-category-btn ${activeCategory === cat ? 'active' : ''}`}
            onClick={() => { setActiveCategory(cat); setQuery(''); }}
          >{cat}</button>
        ))}
      </div>

      <div className="help-content">
        {[...groupedResults.entries()].map(([category, items]) => (
          <div key={category} className="help-section">
            <h2 className="help-section-title">{category}</h2>
            {items.map(item => (
              <div
                key={item.id}
                id={item.id}
                className={`help-card ${hashId === item.id ? 'highlighted' : ''}`}
              >
                <h3 className="help-term">{item.term}</h3>
                <p className="help-definition">{item.definition}</p>
              </div>
            ))}
          </div>
        ))}
        {results.length === 0 && (
          <div className="help-empty">No results found for "{query}"</div>
        )}
      </div>
    </div>
  );
}
